/** 从各个 store 与当前焦点拼出 `ReloadSnapshot`（main.tsx 的空闲门控每 5 秒读一次）。 */
import { useLocalSessionStore } from '../local/localSession.js'
import { isTableIdle, useTableStore, useUiStore } from '../store/index.js'
import { useTalkStore } from '../talk/talkStore.js'
import type { ReloadSnapshot } from './updateIdle.js'

interface FocusLike {
  readonly activeElement?: { readonly tagName?: string; readonly isContentEditable?: boolean } | null
}

export function readReloadSnapshot(doc: FocusLike | undefined = globalThis.document): ReloadSnapshot {
  const t = useTableStore.getState()
  const u = useUiStore.getState()
  const talk = useTalkStore.getState()
  const active = doc?.activeElement ?? null
  const editing =
    active !== null &&
    (active.isContentEditable === true || /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName ?? ''))
  return {
    view: u.view,
    localGame: useLocalSessionStore.getState().status !== 'idle',
    tableIdle: isTableIdle(t.view),
    heroToAct: t.view !== null && t.heroSeat !== null && t.view.actionOn === t.heroSeat,
    connection: t.connection,
    sheetOpen: u.sheet !== null,
    editing,
    talking: talk.composing || talk.draft.trim() !== '',
  }
}
